import '../styles/Beneficios.css' // Importamos el CSS
import BotonContacto from './BotonContacto'

const Beneficios = () => {
    return (
        <section className="beneficios">
            <h2 className="beneficios__titulo">¿Qué es Pretty Woman?</h2>
            <p className="beneficios__texto">
                Somos una Agencia Líder en generar empleo a miles de mujeres que deseen superarse,
                trabajando desde la comodidad de su casa, respetando sus límites y forma de pensar,
                generando excelentes ingresos semanales desde su celular mientras interactúan con
                diferentes tipos de usuarios que se encuentran en todo el mundo.
            </p>

            <h2 className="beneficios__titulo">Beneficios de estar con Pretty Woman</h2>
            <ol className="beneficios__lista">
                <li>
                    Capacitaciones constantes
                    <ol type="I" className="beneficios__sublista">
                        <li>Tips para mejoras en los aplicativos</li>
                        <li>Conferencia con psicóloga</li>
                        <li>Clases de inglés</li>
                    </ol>
                </li>
                <li>Tendrás acompañamiento siempre</li>
                <li>Sorteos semanales</li>
                <li>Acumula tickets para un sorteo especial cada 3 meses</li>
            </ol>

            <h2 className="beneficios__titulo">Requisitos</h2>
            <ol className="beneficios__lista">
                <li>💃 Ser mujer</li>
                <li>🆔 Mayor de edad</li>
                <li>📱 Teléfono inteligente</li>
                <li>📶 Buena señal internet</li>
                <li>💡 Buena iluminación</li>
                <li>😁 Mucha actitud</li>
                <li>🧠 Mente abierta</li>
            </ol>

            {/*<h2 className="beneficios__titulo">Preguntas frecuentes</h2>*/}
            <BotonContacto>
                          {(link) =>
                            link ? (
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noreferrer"
                                className="beneficios-button"
                              >
                                ¡Únete ahora!
                              </a>
                            ) : (
                              <span className="beneficios-button">¡Únete ahora!</span>
                            )
                          }
            </BotonContacto>
        </section>
    )
}

export default Beneficios
